// extracted by mini-css-extract-plugin
module.exports = {"title":"ReservationDetailsItem_title__1x-_k","itemValue":"ReservationDetailsItem_itemValue__2P1yF"};